import Seo from "../components/Seo";
import { LEGAL } from "../content/pages";

export default function Legal({ page }) {
  const l = LEGAL[page];
  return (
    <>
      <Seo path={`/${page}`} title={l.title} description={`${l.title} for GPS Smart Labels by GoAndTrack.`} />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-8 sm:py-20" data-testid={`legal-${page}`}>
        <h1 className="text-4xl font-semibold tracking-tight text-brand-navy sm:text-5xl">{l.title}</h1>
        <p className="mt-4 font-mono text-xs text-brand-slate">{l.updated}</p>
        <div className="mt-12 space-y-10">
          {l.sections.map((s) => (
            <section key={s.h}>
              <h2 className="text-xl font-semibold tracking-tight text-brand-navy">{s.h}</h2>
              <p className="mt-3 text-sm leading-relaxed text-brand-slate">{s.b}</p>
            </section>
          ))}
        </div>
      </section>
    </>
  );
}
